const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/

const YOUTUBE_ID_PATH_PREFIXES = new Set(['watch', 'embed', 'shorts', 'live', 'v'])

const isYoutubeUrl = (url: URL) => url.hostname.replace(/^www\./, '') === 'youtube.com'

const youtubeIdFromPath = (pathname: string) => {
  const [prefix, id] = pathname.split('/').filter(Boolean)

  return YOUTUBE_ID_PATH_PREFIXES.has(prefix) && YOUTUBE_ID.test(id) ? id : undefined
}

export const videoPlayerUrl = (link?: string | null): string => {
  const trimmedLink = link?.trim()

  if (!trimmedLink) {
    return ''
  }

  let url: URL
  try {
    url = new URL(trimmedLink)
  } catch {
    return trimmedLink
  }

  if (!isYoutubeUrl(url)) {
    return trimmedLink
  }

  const videoId = url.searchParams.get('v')
  const id = videoId && YOUTUBE_ID.test(videoId) ? videoId : youtubeIdFromPath(url.pathname)

  return id ? `https://www.youtube.com/watch?v=${id}` : ''
}

export const checkPlaylistLink = (link?: string | null): { isPlaylist: boolean; singleVideoUrl?: string } => {
  let url: URL
  try {
    url = new URL(link?.trim() ?? '')
  } catch {
    return { isPlaylist: false }
  }

  const isPlaylist =
    isYoutubeUrl(url) &&
    (url.searchParams.has('list') ||
      url.searchParams.has('channel') ||
      url.searchParams.has('start_radio') ||
      url.pathname.split('/').filter(Boolean)[0] === 'playlist')

  if (!isPlaylist) {
    return { isPlaylist: false }
  }

  return { isPlaylist: true, singleVideoUrl: videoPlayerUrl(link) || undefined }
}
